import { Observable } from 'rxjs';

/**
 * Opaque data model passed to compiled Handlebars templates by ui-components widgets.
 * The concrete shape is owned by the web frontend; widgets treat it as an opaque bag.
 */
export type GenericHandleBarModel = Record<string, unknown>;

/**
 * DI seam that builds the Handlebars data model. The web frontend provides the concrete
 * implementation (wrapping its `buildHandleBarModel`) so the library stays app-agnostic.
 */
export abstract class HandlebarModelService {
  abstract buildModel(): Observable<GenericHandleBarModel>;
}

/**
 * Returns an empty string when a rendered template still contains unresolved `{{ }}`
 * handlebars tokens, otherwise returns the content unchanged. Mirrors the web frontend's
 * `filterIfHandlebarNotRendered` pure helper.
 */
export function filterIfHandlebarNotRendered(content: string): string {
  const containDoubleBraces = /{{[^{}]*}}/.test(content);
  return containDoubleBraces ? '' : content;
}
